/* global define */
define('paychex.app.messages/drawer/module',[
    'angular',
    'paychex.app.messages/drawer/messageDetail/module'
], function (angular,
             MessageDetailDrawerModule) {
    'use strict';

    return angular.module('paychex.app.messages.drawer', [
        MessageDetailDrawerModule.name
    ]);
});

